import * as React from 'react'
import { Link } from 'react-router-dom'

import { Fieldset, Legend } from '@paytrace/pt-skel/Component'

interface Props { }

export function Level3 (props: Props) {
  return (
    <>
      <div className='float-right'>
        <a className='help-link' href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025980451/Add+Level+3+Data">Help</a>
      </div>
      <h1>Add Level 3 Data</h1>
      <hr className='clear' />

      <Fieldset>
        <Legend title='Eligible Transactions' />

        <table>
          <thead>
          <tr>
            <th>ID</th>
            <th>Amount</th>
            <th>Card</th>
            <th>Name</th>
            <th>Reason</th>
          </tr>
          </thead>
          <tbody />
        </table>
      </Fieldset>

      <Fieldset>
        <Legend title='Default Data' />

        <div className='form-group'>
          <Link className='link-btn form-btn' to='/VisaL3Default.pay'>Set Default Data - Visa</Link>
        </div>

        <div className='form-group'>
          <Link className='link-btn form-btn' to='/MCRDL3Default.pay'>Set Default Data - MasterCard</Link>
        </div>
      </Fieldset>
    </>
  )
}

export default Level3
